<template>
  <div>
    <table class="table-pdf" style="width: 100%; border-collapse: collapse;">
      <thead>
        <tr style="background-color: #444; color: #fff;">
          <th style="padding: 5px;">Atendimento</th>
          <th style="padding: 5px; text-align: left;">Serviço</th>
          <th style="padding: 5px;">Qtd</th>
          <th style="padding: 5px;">Vlr Unitário</th>
          <th style="padding: 5px; text-align: right;">Vlr Total</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" style="border-bottom: 1px solid #ddd;">
          <td style="padding: 5px; text-align: center;">{{ item.dtatendimento }}</td>
          <td style="padding: 5px; text-align: left;">{{ item.descrservico || item.servico }}</td>
          <td style="padding: 5px; text-align: center;">{{ item.quantidade }}</td>
          <td style="padding: 5px; text-align: center;">{{ item.vlrunitario | currency }}</td>
          <td style="padding: 5px; text-align: right;">{{ item.vlrtotal | currency }}</td>
        </tr>
        <tr style="background-color: #eee; font-weight: bold;">
          <td colspan="2" style="padding: 5px; text-align: right;">TOTAL DA VIDA:</td>
          <td style="padding: 5px; text-align: center;">{{ totalQtd }}</td>
          <td style="padding: 5px; text-align: center;">-</td>
          <td style="padding: 5px; text-align: right;">{{ totalValor | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["items"],
  computed: {
    totalQtd() {
      return this.items.reduce((acc, cur) => acc + (cur.quantidade || 0), 0);
    },
    totalValor() {
      return this.items.reduce((acc, cur) => acc + (cur.vlrtotal || 0), 0);
    }
  },
  filters: {
    currency(valor) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(valor);
    }
  }
};
</script>